var Tools = require('../../deploynaut/js/tools.jsx');
var CodeBuilder = require('./CodeBuilder.jsx');

Tools.install(CodeBuilder, 'CodeBuilder');
